import { Box, Container, Stack, Typography } from "@mui/material";
import MuiCard from "@mui/material/Card";
import { animated, useSprings } from "@react-spring/web";
import { useState } from "react";
import { Waypoint } from "react-waypoint";
import PropTypes from "prop-types";

const Card = (props) => (
  <MuiCard
    sx={{
      backgroundColor: "white",
      position: "relative",
      p: 2,
      shadow: "none",
      width: { xs: "100%", sm: 300 },
      marginInline: "auto",
      height: 240
    }}
    {...props}
  >
    {props.children}
    <Box
      sx={{
        position: "absolute",
        bottom: -40,
        right: { xs: -80, sm: -30 },
        width: "50%",
        height: 120,
        zIndex: -1
      }}
    >
      <svg>
        <polygon
          points="60 3, 120 25, 120 75, 60 100, 3 75, 3 25"
          fill="transparent"
          stroke="#eee"
          strokeWidth={2}
          transform="scale(1.5)"
        />
        <polygon
          points="60 13, 110 31, 110 69, 60 90, 13 69, 13 31"
          fill="transparent"
          stroke="#cecece77"
          strokeWidth={2}
          transform="scale(1.5)"
        />
        <polygon
          points="60 23, 100 41, 100 57, 60 80, 23 57, 23 37"
          fill="transparent"
          stroke="#cecece99"
          strokeWidth={2}
          transform="scale(1.5)"
        />
      </svg>
    </Box>
  </MuiCard>
);

Card.propTypes = {
  children: PropTypes.node.isRequired
};

export default function Services() {
  const [inview, setInview] = useState(false);
  const springs = useSprings(
    3,
    [
      { axis: "x", from: -400 },
      { axis: "y", from: 400 },
      { axis: "x", from: 400 }
    ].map((i) => ({
      from: { [i.axis]: inview ? i.from : 0 },
      to: { [i.axis]: 0 },
      config: { duration: 700 },
      delay: 200
    }))
  );
  return (
    <Box sx={{ width: "100%" }} id="services">
      <Container maxWidth="lg" sx={{ borderTop: "1px solid #edebeb", py: 4 }}>
        <Box sx={{ margin: "auto", width: "100%", textAlign: "center" }}>
          <Typography variant="h3">Services</Typography>
          <Waypoint onEnter={() => setInview(true)}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="center"
              spacing={2}
              sx={{ maxWidth: 800, mx: "auto" }}
            >
              <animated.div style={springs[0]}>
                <Card>
                  <Typography variant="h4">Development</Typography>
                  <Typography variant="body">
                    Website Development
                    <br />
                    Landing Page Development
                    <br />
                    Software Development
                    <br />
                    LMS Development
                    <br />
                  </Typography>
                </Card>
              </animated.div>
              <animated.div style={springs[1]}>
                <Card>
                  <Typography variant="h4">Traffic</Typography>
                  <Typography variant="body">
                    Sale Funnel Design
                    <br />
                    Digital Ads
                    <br />
                    Native Ads
                    <br />
                  </Typography>
                </Card>
              </animated.div>
              <animated.div style={springs[2]}>
                <Card>
                  <Typography variant="h4">Awareness</Typography>
                  <Typography variant="body">
                    PR & News
                    <br />
                    Community Building
                    <br />
                    Listing
                    <br />
                    Social Media Optimization
                    <br />
                    Reviews Building
                    <br />
                    Influencer Marketing
                    <br />
                    SEO
                  </Typography>
                </Card>
              </animated.div>
            </Stack>
          </Waypoint>
        </Box>
      </Container>
    </Box>
  );
}
